import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  isSensitivePath,
  syncAnalyticsWithRoute,
  trackPageView,
} from "utils/analytics";

export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    // Must run before the sensitive-path early return so recording stops.
    syncAnalyticsWithRoute(location.pathname);
    // Token-bearing public pages are never tracked (see isSensitivePath).
    if (isSensitivePath(location.pathname)) return;
    trackPageView(location.pathname + location.search);
  }, [location]);
}
